module.exports = __webpack_public_path__ + "static/img/retroflowers.743bd50.svg";